import React, { useContext } from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { fade, makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

import CartButton from '../../components/header/CartButton'
import SessionContext from '../../contexts/SessionContext'
import Link from 'next/link'
import AccountCircle from '@material-ui/icons/AccountCircle'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { Typography } from '@material-ui/core'
import { getFirebaseApp } from '../../config/firebase'
import { useRouter } from 'next/router'
const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  menu: {
    zIndex: theme.zIndex.modal + 400 + ' !important',
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justify: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    color: '#fff',
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  cusColor: c => ({
    color: c.color,
  }),
}))

export default function CentralUserButton(params) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const { session, actions, config } = useContext(SessionContext)
  let router = useRouter()
  let { storeSlug } = router.query
  let fontColor =
    config && config.hasOwnProperty('web_theme_font_color') ? config.web_theme_font_color : ''

  let c = {
    color:
      storeSlug != undefined
        ? fontColor
          ? `${fontColor}` + ' !important'
          : '#fff !important'
        : '#327bbf  !important',

  }
  const classes = useStyles(c)

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget)
  }
  const signOut = event => {
    getFirebaseApp(config.tenant_id, config.firebase_api_key).auth.signOut()
    actions.signOut()
  }

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <>
      {!isEmpty(get(session, 'user')) ? (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          id={menuId}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMenuOpen}
          onClose={handleMenuClose}
          classes={{ paper: 'user-menu' }}
          className={classes.menu}
        >
          <MenuItem onClick={handleMenuClose}>
            <Link href={'/profile'}>
              <Typography varient="body1">Profile</Typography>
            </Link>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <Link href={'/myorders'}>
              <Typography varient="body1">My Orders</Typography>
            </Link>
          </MenuItem>
          <MenuItem onClick={signOut}>
            <Typography varient="body1">Sign Out</Typography>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          id={menuId}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMenuOpen}
          onClose={handleMenuClose}
          classes={{ paper: 'user-menu' }}
          className={classes.menu}
        >
          <MenuItem>
            {' '}
            <Link href={storeSlug ? '/store/' + storeSlug + '/auth' : '/auth'}>
              <Typography varient="body1">Sign In</Typography>
            </Link>{' '}
          </MenuItem>
        </Menu>
      )}
    </>
  )

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <>
      {!isEmpty(get(session, 'user')) ? (
        <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          id={mobileMenuId}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMobileMenuOpen}
          onClose={handleMobileMenuClose}
          className={classes.menu}
        >
          <MenuItem onClick={handleMenuClose}>
            <Link href={'/profile'}>Profile</Link>
          </MenuItem>
          <MenuItem onClick={handleMenuClose}>
            <Link href={'/myorders'}>My Orders</Link>
          </MenuItem>
          <MenuItem onClick={signOut}>Sign Out</MenuItem>
        </Menu>
      ) : (
        <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          id={mobileMenuId}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMobileMenuOpen}
          onClose={handleMobileMenuClose}
          className={classes.menu}
        >
          <MenuItem>
            {' '}
            <Link href={storeSlug ? '/store/' + storeSlug + '/auth' : '/auth'}>
            Sign In
            </Link>
          </MenuItem>
        </Menu>
      )}
    </>
  )
  return (
    <>
      <div className={classes.sectionDesktop}>
        {storeSlug && (
          <CartButton
            href={'/store/' + storeSlug + '/cart'}
            quantity={get(session, 'itemsInCart')}
          />
        )}

        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          className={classes.cusColor}
        >
          <AccountCircle />
        </IconButton>
      </div>
      <div className={classes.sectionMobile}>
        {storeSlug && (
          <CartButton
            className={classes.cusColor}
            href={'/store/' + storeSlug + '/cart'}
            quantity={get(session, 'itemsInCart')}
          />
        )}
        <IconButton
          aria-label="show more"
          aria-controls={mobileMenuId}
          aria-haspopup="true"
          onClick={handleMobileMenuOpen}
          color="inherit"
          className={classes.cusColor}
        >
          <AccountCircle />
        </IconButton>
      </div>
      {renderMobileMenu}
      {renderMenu}
    </>
  )
}
